import {
  TrackerMealConnectorApollo,
  TrackerEditMealConnectorApollo,
  useAppContext,
  TrackerRemoveMealConnectorApollo,
  SaveAsUserMealConnectorApollo,
  formatIsoDate,
} from '@front-activerse/common-components';
import { useParams, useLocation } from 'react-router-dom';
import TrackerMealContainer from './TrackerMealContainer';
import TrackerNoAccess from '../NoAccess/TrackerNoAccess';

const TrackerMealPage: React.FC = () => {
  const { date, dietMealId } = useParams();
  const dateString = date ? date : formatIsoDate(new Date());
  const { post } = useAppContext();

  const location = useLocation();

  const aiAccess = sessionStorage.getItem('aiAccess');
  const dietAccess = sessionStorage.getItem('dietAccess');

  if (!dietMealId) {
    return <div>Missing parameters</div>;
  }

  if (aiAccess === 'true' || dietAccess === 'true') {
    return (
      <TrackerMealConnectorApollo mealId={+dietMealId}>
        {(trackerMealData: any) => (
          <TrackerEditMealConnectorApollo post={post} originalDate={dateString}>
            {({ editMeal }: { editMeal: (input: any) => Promise<any> }) => (
              <TrackerRemoveMealConnectorApollo date={dateString}>
                {({ removeMeal }) => (
                  <SaveAsUserMealConnectorApollo post={post}>
                    {({ saveAsUserMeal }: { saveAsUserMeal: (input: any) => Promise<any> }) => (
                      <TrackerMealContainer
                        {...trackerMealData}
                        loading={trackerMealData.loading}
                        editMeal={editMeal}
                        key={location.key}
                        removeMeal={removeMeal}
                        date={dateString}
                        saveAsUserMeal={saveAsUserMeal}
                        dietMealId={dietMealId}
                      />
                    )}
                  </SaveAsUserMealConnectorApollo>
                )}
              </TrackerRemoveMealConnectorApollo>
            )}
          </TrackerEditMealConnectorApollo>
        )}
      </TrackerMealConnectorApollo>
    );
  }

  return <TrackerNoAccess />;
};

export default TrackerMealPage;
